import React, {useState} from 'react';
import {OntData} from "./component/technicalcomponent/OntData";
import {
  CpeMacAddressInput
} from "./component/technicalcomponent/CpeMacAddressInput";
import {PortGfGvInput} from "./component/technicalcomponent/PortGfGvInput";
import {PortGfApInput} from "./component/technicalcomponent/PortGfApInput";
import {HomeIdInput} from "./component/technicalcomponent/HomeIdInput";
import BarcodeModal from "../scanner/BarcodeModal";
import {filterErrorForField} from "../../utils/ErrorUtils";

const TechnicalComponentsContent = ({
  unitId,
  technicalData,
  updateUnitTechnicalComponent,
  errors
}) => {
  const [barcodeModal, setBarcodeModal] = useState(false);
  const [scanTargetField, setScanTargetField] = useState('');

  const startBarcodeScanning = (fieldPath) => {
    setScanTargetField(fieldPath);
    setBarcodeModal(true);
  };

  const handleScanResult = (result) => {
    if (scanTargetField && result) {
      updateUnitTechnicalComponent(scanTargetField, result);
    }
    setBarcodeModal(false);
    setScanTargetField('');
  };

  return (
      <div>
        <h6 className="text-sm font-medium text-gray-700 mb-3">Technische
          Komponenten</h6>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <OntData
                technicalData={technicalData}
                onChange={updateUnitTechnicalComponent}
                startBarcodeScanning={startBarcodeScanning}
                errors={filterErrorForField(errors, 'technicalData.ont')}
            />
          </div>

          <div className="space-y-2">
            <CpeMacAddressInput
                technicalData={technicalData}
                onChange={updateUnitTechnicalComponent}
                startBarcodeScanning={startBarcodeScanning}
                errors={filterErrorForField(errors, 'technicalData.cpe.mac_address')}
            />
          </div>

          <div className="space-y-2">
            <PortGfGvInput
                technicalData={technicalData}
                onChange={updateUnitTechnicalComponent}
                errors={filterErrorForField(errors, 'technicalData.port_gf_gv')}
            />
          </div>

          <div className="space-y-2">
            <PortGfApInput
                technicalData={technicalData}
                onChange={updateUnitTechnicalComponent}
                errors={filterErrorForField(errors, 'technicalData.port_gf_ap')}
            />
          </div>

          <HomeIdInput
              technicalData={technicalData}
              onChange={updateUnitTechnicalComponent}
              startBarcodeScanning={startBarcodeScanning}
          />
        </div>

        {barcodeModal && (
            <BarcodeModal
                key={unitId}
                setBarcodeModal={setBarcodeModal}
                handleScanResult={handleScanResult}
            />
        )}
      </div>
  );
}

export default TechnicalComponentsContent;
